

















































import ReportTable from '@/components/ReportTable.vue';
import Vue from 'vue';
import axios from 'axios';

const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';

export default Vue.extend({
  name: 'NonTradingCustomers',
  components: {ReportTable},
  data() {
    return {
      depots: [] as string[],
      weeks: [] as number[],
      selectedDepot: 'all',
      tableData: null as null | string[][],
      loading: false,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.depots = (await axios.get<{ depots: string[] }>(`${BASE_URL}/reports/depots/`)).data.depots;
      const response = await axios.get(`${BASE_URL}/reports/get-non-trading-customers/${this.selectedDepot}/`);
      this.tableData = response.data.nonTradingCustomers;
      this.weeks = response.data.weeks;
      this.loading = false;
    },
    getColor(value: string) {
      if (parseInt(value, 10) === 0) {
        return '#ffaaaa';
      } else {
        return 'inherit';
      }
      let color = 'green';
      if (parseFloat(value) < 10) {
        color = 'red';
      } else if (parseFloat(value) > 10 && parseFloat(value) < 20) {
        color = 'orange';
      } else if (parseFloat(value) > 20) {
        color = 'green';
      }
      return color;
    },
  },
});
